/**
 * Persistence только UI-флагов библиотеки тура (не серверный прогресс).
 * Namespace по userId, чтобы не смешивать аккаунты на одном браузере.
 */

const PREFIX = "gpml:onboarding";

function storageKey(userId: string, suffix: string): string {
  return `${PREFIX}:${userId}:${suffix}`;
}

export type OnboardingUiFlags = {
  seenTours: string[];
  welcomeSeen: boolean;
};

const DEFAULT_FLAGS: OnboardingUiFlags = {
  seenTours: [],
  welcomeSeen: false,
};

export function readOnboardingUiFlags(userId: string): OnboardingUiFlags {
  try {
    const raw = localStorage.getItem(storageKey(userId, "ui"));
    if (!raw) return { ...DEFAULT_FLAGS };
    const parsed = JSON.parse(raw) as Partial<OnboardingUiFlags>;
    return {
      seenTours: Array.isArray(parsed.seenTours) ? parsed.seenTours.map(String) : [],
      welcomeSeen: Boolean(parsed.welcomeSeen),
    };
  } catch {
    return { ...DEFAULT_FLAGS };
  }
}

export function writeOnboardingUiFlags(userId: string, flags: OnboardingUiFlags): void {
  try {
    localStorage.setItem(storageKey(userId, "ui"), JSON.stringify(flags));
  } catch {
    /* ignore quota / private mode */
  }
}

export function markTourSeenUi(userId: string, tourKey: string): void {
  const flags = readOnboardingUiFlags(userId);
  if (!flags.seenTours.includes(tourKey)) {
    flags.seenTours = [...flags.seenTours, tourKey];
  }
  if (tourKey === "welcome") {
    flags.welcomeSeen = true;
  }
  writeOnboardingUiFlags(userId, flags);
}

/** Ключ «ожидающий тур» после F5 — не блокирует серверный active tour. */
export function setPendingTour(userId: string, tourKey: string | null): void {
  try {
    const key = storageKey(userId, "pending");
    if (!tourKey) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, tourKey);
  } catch {
    /* ignore */
  }
}

export function getPendingTour(userId: string): string | null {
  try {
    return localStorage.getItem(storageKey(userId, "pending"));
  } catch {
    return null;
  }
}
